import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateTask } from "@coworker/apprestructured/src/task-management/types/Task";
import { createTasksBatch } from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { invalidateTaskQueries } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { getRefillAreaIdFromLocation } from "@fixa/store-locations";

export const useCreateTasksBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tasks: CreateTask[]) => createTasksBatch(tasks),
    onSuccess: async (tasks) => {
      await invalidateTaskQueries(queryClient);

      if (tasks && tasks.length > 0) {
        const firstTask = tasks[0];
        const refillLocation = firstTask?.details?.["refill_location"] as
          { slid?: string } | undefined;
        if (refillLocation?.slid) {
          const refillAreaId = getRefillAreaIdFromLocation(refillLocation.slid);
          if (refillAreaId) {
            await queryClient.invalidateQueries({
              queryKey: ["articlesByRefillArea", refillAreaId],
            });
          }
        }
      }
    },
    onError: (error) => {
      console.error("Error while creating tasks batch", error);
    },
  });
};
